import { loadAnalytics } from 'common/metrics'

const loadCookieConsent = () => {
  if (window.cookieconsent) return

  var scriptTag = document.createElement('script')
  scriptTag.src = 'https://cdn.tirant.com/cookieconsent/cookieconsent-1.5.0.min.js'

  scriptTag.onload = startCookieConsent
  scriptTag.onreadystatechange = startCookieConsent

  document.head.appendChild(scriptTag)
}

const startCookieConsent = () => {
  if (window.cookieconsent) return

  if (typeof CookieConsent == 'undefined') {
    console.warn('[tolweb] CookieConsent no está cargado. El script puede haber fallado.')

    if (window.newrelic) {
      const CookieConsentError = new Error('CookieConsent no está cargado. El script puede haber fallado')
      window.newrelic.noticeError(CookieConsentError, {
        'tirant_error_id': 'cookieconsent',
        'tirant_project': 'tolweb',
        'tirant_file': 'app/javascript/common/cookies.js',
      })
    }
    return
  }

  window.cookieconsent = new CookieConsent({
    sections: gon.cookieconsent.sections.map((section) => CookieConsent[section]),
    lang: gon.iso_language,
    version: gon.cookieconsent.version
  })

  window.cookieconsent.start()

  document.dispatchEvent(new CustomEvent('tolweb:cookieconsent:started'))

  document.addEventListener('click', (event) => {
    if (event.target.matches('.cookie_config_link'))
      window.cookieconsent.show_config_modal()
  })

  if(typeof gon !== 'undefined' && gon.smart_chat && window.cookieconsent.get_allowed().includes('chat')) {
    smartChat()
  }

  if(gon.analytics && window.cookieconsent.get_allowed().includes('analytics')) {
    loadAnalytics()
  }

  if(window.cookieconsent.get_allowed().includes('personalization')) {
    document.dispatchEvent(new CustomEvent('tolweb:cookieconsent:personalization:accepted'))
  }

  document.addEventListener('cookieconsent.saved', function (event) {
    if (typeof gon !== 'undefined' && gon.smart_chat && event.detail.currentSections.includes('chat')) {
      smartChat()
    }
    if (gon.analytics && event.detail.currentSections.includes('analytics')) {
      loadAnalytics()
    }
    if (event.detail.currentSections.includes('personalization')) {
      document.dispatchEvent(new CustomEvent('tolweb:cookieconsent:personalization:accepted'))
    }
  })
}

export {
  loadCookieConsent,
  startCookieConsent
}
